const Priority = [
  {
    id: "express",
    name: "Express",
  },
  {
    id: "priority",
    name: "Priority",
  },
  {
    id: "economic",
    name: "Economic",
  },
];
export default Priority;
